import examineList from './examineList.vue';
import allList from './allList.vue';
import { changeList } from './request';
export default {
  components: {
    examineList,
    allList
  },
  data() {
    return {
      current: 0,
      num: 0
    };
  },
  created() {
    this.getNumFun();
  },
  methods: {
    getNumFun() {
      changeList({
        page: 1,
        pageSize: 3,
        status: 2
      }).then(res => {
        this.num = res.totalNum;
      });
    }
  }
};